// Home.js
import React from 'react';
import aboutImg from '../assets/images/about-img-01.png';
import missionImg from '../assets/images/mission-thumb-img.png';
import visionImg from '../assets/images/vision-thumb-img.png';
import valuesImg from '../assets/images/values-thumb-img.png';
import './Pages.css';

function AboutUs() {
  return (
    <section id="about-us" className='has-fixed-header py-4 pb-0'>
        <div className='container-fluid p-0 py-4'>
          <div className="container">
            <div className="row align-items-star mb-4 pb-5 border-bottom">
              <div className="col-md-6 col-sm-12">
                  <div className='content-section'>
                  <h1 className="display-6 text-primary">About Elevate</h1>
                    <p className="lead text-black">
                      At Elevate, we specialize in delivering innovative risk adjustment solutions tailored to the healthcare industry. Our mission is to empower healthcare providers and payers to navigate complex regulatory environments with confidence, improve patient outcomes, and optimize operational efficiency.
                    </p>

                    <p className="text-style">
                    With a customer-first approach, Elevate is dedicated to designing solutions that are not only effective but also intuitive and easy to implement. By leveraging cutting-edge technology and deep domain expertise, we ensure that our clients stay ahead in the ever-evolving healthcare landscape.
                    </p>
                  </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <img
                  src={aboutImg}
                  alt="About Elevate"
                  className="img-fluid"
                />
              </div>
            </div>


            <div className="row mt-5">
              <div className="col text-center">
                <h2 className="display-6 text-primary">Why Choose Elevate?</h2>
                <p className="text-style col-md-8 col-sm-12 mx-auto">
                  With years of expertise and a proven track record, Elevate is the trusted partner for healthcare providers and payers looking to excel in risk adjustment. We combine advanced technology with personalized support to deliver solutions that make a real difference.
                </p>
              </div>
            </div>
        </div>
      </div>

      <div className='container-fluid mvv-section bg-primary-light'>
        <div className='container'>
            <div className="row">
                <div className="col-md-4 col-sm-12 text-center">
                  <div className="card card-minHeight border-0 shadow-sm py-3 px-3">
                    <div className='card-header'>
                      <img src={missionImg} alt='mission image' className='img-fluid' />
                    </div>
                    <div className='card-info'>
                        <h3 className="card-title my-3 text-left">Our Mission</h3>
                        <p className="card-text">
                          To simplify risk adjustment and support our clients in delivering exceptional patient care while maintaining compliance and efficiency.
                        </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-sm-12 text-center">
                  <div className="card card-minHeight border-0 shadow-sm py-3 px-3">
                      <div className='card-header'>
                        <img src={visionImg} alt='mission image' className='img-fluid' />
                      </div>
                      <div className='card-info'>
                          <h3 className="card-title my-3 text-left">Our Vision</h3>
                          <p className="card-text">
                          To lead the healthcare industry with cutting-edge solutions that drive measurable outcomes and foster innovation.
                          </p>
                      </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-12 text-center">
                  <div className="card card-minHeight border-0 shadow-sm py-3 px-3">
                      <div className='card-header'>
                        <img src={valuesImg} alt='mission image' className='img-fluid' />
                      </div>
                      <div className='card-info'>
                          <h3 className="card-title my-3 text-left">Our Values</h3>
                          <p className="card-text">
                          Integrity, innovation, collaboration, and a relentless commitment to excellence in everything we do.
                          </p>
                      </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

    </section>
  );
}

export default AboutUs;